import CompanyCompareIcon from 'Components/common/assets/svgIcons/CompanyCompareIcon';
import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import CompaniesSvg from 'Components/layout/assets/CompaniesSvg';
import { Company } from 'Types/CompaniesTypes';
import { parseColorGradientMixture } from 'Utils/UtilityFunctions';
import {
  maxWidth, primaryColor, retina, secondaryFont, wMedium,
} from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';

const StyleWrapper = styled.div`
  &:hover {
      border: 1px solid ${primaryColor};
    .company-compare-svg {
      path {
        fill: ${primaryColor};
      }
    }
  }
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 19px 24px 20px 17px;
  border-radius: 10px;
  border: 1px solid #DADADA;
  background: #FFF;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.12);
  margin-bottom: 10px;
  width: 100%;
  @media all and (max-width: ${maxWidth}), ${retina} {
    padding: 15px 24px 16px 14px;
  }
.card-name-img-div {
  display: flex;
  align-items: center;
  width: calc(100% - 22px);
  @media all and (max-width: ${maxWidth}), ${retina} {
    width: calc(100% - 20px);
  }
  .company-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 58px;
    height: 58px;
    border-radius: 50%;
    border: 2px solid #979797;
    margin-right: 17px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 48px;
      height: 48px;
    }
    .company-logo-inner {
      width: 31px;
      height: 31px;
    }
  }
  .company-name {
    width: calc(100% - 73px);
    color: #000;
    font-family: ${secondaryFont};
    font-size: 20px;
    font-weight: ${wMedium};
    line-height: 24px;
    letter-spacing: -0.417px;
    margin-bottom: 0px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 18px;
      width: calc(100% - 63px);
    }
  }
}
.company-compare-svg {
  width: 22px;
  min-width: 22px;
  height: 17px;
  cursor: pointer;
  @media all and (max-width: ${maxWidth}), ${retina} {
    width: 20px;
    min-width: 20px;
    height: 15px;
  }
  path {
    fill: #616161;
  }
}
`;
type Props = {
  noCompetitor?: boolean
  company?: Company
};

const defaultProps = {
  noCompetitor: false,
  company: {},
};

const SmartCompanyListCard = function SmartCompanyListCard(props: Props) {
  const { company, noCompetitor } = props;
  return (
    <StyleWrapper>
      <div className="card-name-img-div">
        {noCompetitor ? (
          <div className="company-logo">
            <CompaniesSvg color="#616161" />
          </div>
        ) : (
          <PeopleWidgetWithOutHolo
            logo={company?.companyLogo || ''}
            companyId={company?.companyId}
            diameter="49px"
            diameterSm="49px"
            diameterXsm="49px"
            ringPadding="2px"
            ringPaddingSm="2px"
            margin="0px 17px 0px 0px"
            marginSm="0px 17px 0px 0px"
            wrapperColor={parseColorGradientMixture(company?.companyPersonality || [])}
            sapPersonAppear
          />
        )}
        <h3 className="company-name text-truncate">{noCompetitor ? 'Add a competitor' : company?.companyName}</h3>
      </div>
      <CompanyCompareIcon color={primaryColor} className="company-compare-svg" />
    </StyleWrapper>
  );
};
SmartCompanyListCard.defaultProps = defaultProps;
export default SmartCompanyListCard;
